import React, { useState, useRef, useEffect, useCallback } from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera, faCrop, faTimes } from '@fortawesome/free-solid-svg-icons';

import Camera, { FACING_MODES } from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';

import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { T } from "react-translator-component";

const CameraCropper = ({ type = 'normal', title, desc, onPhotoComplete, onClose }) => {
  const imgRef = useRef(null);
  const previewContainer = useRef(null);
  const previewPhoto = useRef(null);
  const previewCanvasRef = useRef(null);
  const [cameraModePreview, setCameraModePreview] = useState(null);
  const [croppingMode, setCroppingMode] = useState(false);
  const [crop, setCrop] = useState({ unit: '%', width: 50, height: 50, x: 25, y: 25 });
  const [cropImg, setCropImg] = useState(null);
  const [completedCrop, setCompletedCrop] = useState(null);
  const [previewSizes, setPreviewSizes] = useState([10, 10])
  const [proportionImg, setProportionImg] = useState('landscape');

  const onLoad = useCallback((img) => {
    imgRef.current = img;
  }, []);

  const getPhoto = useCallback(() => {
    if (croppingMode) {
      return previewCanvasRef.current.toDataURL("image/jpeg");
    } else {
      return cameraModePreview
    }

  }, [croppingMode, cameraModePreview])

  useEffect(() => {
    if (/*!completedCrop || */!previewCanvasRef.current || !imgRef.current) {
      return;
    }

    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const _crop = completedCrop ?? crop;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext('2d');
    const pixelRatio = window.devicePixelRatio;

    canvas.width = _crop.width * pixelRatio;
    canvas.height = _crop.height * pixelRatio;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = 'high';

    ctx.drawImage(
      image,
      _crop.x * scaleX,
      _crop.y * scaleY,
      _crop.width * scaleX,
      _crop.height * scaleY,
      0,
      0,
      _crop.width,
      _crop.height
    );

  }, [completedCrop, crop, croppingMode]);

  useEffect(() => {
    if (previewContainer?.current && previewPhoto?.current) {
      const image = previewPhoto.current;

      let _width = 0;
      let _height = 0;

      if (image.naturalWidth > image.naturalHeight) {
        _width = previewContainer.current.offsetWidth;
        _height = image.naturalHeight / (image.naturalWidth / previewContainer.current.offsetWidth);
      } else {
        _height = previewContainer.current.offsetHeight;
        _width = image.naturalWidth / (image.naturalHeight / previewContainer.current.offsetHeight);
      }

      setPreviewSizes([ _width, _height ]);
      setProportionImg(_width > _height ? 'landscape' : 'portrait')
    }
  }, [cameraModePreview, previewContainer, imgRef])

    return (
      <Container 
        style={{ overflow: 'hidden', height: '100%', width: '100%', display: 'flex' }} 
        className={`pl-0 pr-0 bg-dark text-center`}
      >
      <Button className={'close-button'} onClick={() => { onClose() }}><FontAwesomeIcon style={{fontSize: "20", paddingLeft: '0px', color: '#FFF'}} icon={faTimes}/></Button>
      {!cameraModePreview && <div style={{ display: 'flex', alignItems: 'center', margin: "auto" }}><Camera
    // isFullscreen={true}
    style={{ display: 'flex' }}
    isImageMirror = {type === 'selfie'}
    idealFacingMode = {type === 'selfie' ? FACING_MODES.USER : FACING_MODES.ENVIRONMENT}
    // imageType = {IMAGE_TYPES.JPG}
    // imageCompression = {0.9}
    isFullscreen = {false}
    sizeFactor = {1}
    isMaxResolution = {type !== 'selfie'}
    onTakePhoto = { (dataUri) => { setCameraModePreview(dataUri); } }
    /></div>}
    
        {cameraModePreview && <div style={{ display: 'flex', flexDirection: 'column', height: '100%', marginLeft:"auto" , marginRight:"auto" }}>

      <div style={{ flex: 0, display: "flex", flexDirection: "column" }} className={`text-white mb-0 mx-2`}>
        <h3 className={`text-white mt-4`}>{title}</h3>
        <p style={{ fontSize: 18, fontWeight: 200 }}>{desc}</p>
      </div>

      <div className="vico-camera-cropper" style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 20, overflowY: 'scroll'}} ref={previewContainer}>
        {croppingMode && <><ReactCrop 
        style={{ width: previewSizes[0], height: previewSizes[1] }}
        src={cropImg} 
        onImageLoaded={onLoad}
        crop={crop} 
        ruleOfThirds
        keepSelection={true}
        // locked={true}
        // circularCrop
        // rotate={cropRotate}
        onChange={(c) => { setCrop(c) }}
        onComplete={(c) => { setCompletedCrop(c) }}
      />
      <canvas
            ref={previewCanvasRef}
            // Rounding is important so the canvas width and height matches/is a multiple for sharpness.
            style={{
              position: 'absolute',
              right: 15,
              bottom: 68,
              maxWidth: 120,
              maxHeight: 120,
              borderColor: '#777',
              borderWidth: 1,
              borderStyle: "solid",
              width: '100%', // Math.round(completedCrop?.width / 3 ?? 0),
              height: 'auto', // Math.round(completedCrop?.height / 3 ?? 0),
              display: 'none'
            }}
          /></>}
        {!croppingMode && <img ref={previewPhoto} alt="" src={cameraModePreview} style={{ width: (proportionImg === 'landscape' ? '100%' : 'auto'), height: (proportionImg === 'portrait' ? '100%' : 'auto'), maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />}
    </div>

          <div style={{ flex: 0, display: "flex", flexDirection: "column" }} className={`text-white mb-2 mx-2 vico-camera-cropper-footer`}>
      {!croppingMode && <div style={{ flex: 1, flexDirection: 'row', marginBottom: 8 }}>
          <Button
              size={'lg'} 
              variant={'custom'}
              type={'button'}
              style={{ backgroundColor: 'rgba(255, 255, 255, 0.25)', borderRadius: 8, height: 40, padding: 0, marginLeft: 3, marginRight: 3, paddingLeft: 10, paddingRight: 10 }}
              onClick={() => { setCameraModePreview(null); setCroppingMode(false); } }>
                <FontAwesomeIcon className={`mr-2`} size="sm" icon={faCamera} color="#FFF"/>
                <span style={{ color: '#FFF', verticalAlign: 'initial', textTransform: 'uppercase' }}>{T('checkin.camera.repeat')}</span>
              </Button>
          <Button
              size={'lg'} 
              variant={'custom'}
              type={'button'}
              style={{ backgroundColor: 'rgba(255, 255, 255, 0.25)', borderRadius: 8, height: 40, padding: 0, marginLeft: 3, marginRight: 3, paddingLeft: 10, paddingRight: 10 }}
              onClick={() => { setCroppingMode(true); setCropImg(cameraModePreview); } }>
                <FontAwesomeIcon className={`mr-2`} size="sm" icon={faCrop} color="#FFF"/>
                <span style={{ textTransform: 'uppercase', color: '#FFF', verticalAlign: 'initial' }}>{T('checkin.camera.crop')}</span>
              </Button>

      </div>}
    {croppingMode && <Row>
        <Col xs={6} className={`pr-1`}>
        <Button
            size={'lg'} 
            variant={'link'}
            type={'button'}
            style={{ backgroundColor: '#666', color: '#FFF', textTransform: 'uppercase' }}
            block={true}
            onClick={() => { setCroppingMode(false) }}
            >
              {T('general.cancel')}
          </Button>
        </Col>
        <Col xs={6} className={`pl-1`}>
          <Button
            size={'lg'} 
            variant={'link'}
            type={'button'}
            style={{ backgroundColor: 'blue', color: '#FFF', textTransform: 'uppercase' }}
            block={true}
            onClick={() => { setCroppingMode(false); setCameraModePreview(getPhoto()); }}
            >
              {T('checkin.camera.crop')}
          </Button>
        </Col>
      </Row>}
      {!croppingMode && <Row>
        <Col xs={12}>
          <Button
            size={'lg'} 
            variant={'link'}
            type={'button'}
            style={{ backgroundColor: 'green', color: '#FFF', textTransform: 'uppercase' }}
            block={true}
            onClick={() => onPhotoComplete(getPhoto())}
            >
              {T('checkin.camera.use-photo')}
          </Button>
        </Col>
      </Row>}
    </div>
  </div>}
      
      </Container>
    );

}

export default CameraCropper;